import React, { useEffect, useState } from 'react';
import { randBgNumber, generateWLBgURL } from 'src/helpers/generateWLBgURL';
import styled, { css } from 'styled-components';

import previews from 'src/images/wl_header_previews';

/**
 * Нужно сохранить данные классы и структуру,
 * поскольку bg может устанавливаться скриптом, приходящим с админки
 */

const HEADER_BG_IMAGE_CLASSNAME = 'header_bg-image';
const HEADER_BG_PRELOADER_CLASSNAME = 'header_bg-preloader';

export const WLHeaderBackground = () => {
  const [preloaderBgClassname, setPreloaderBgClassname] = useState(
    HEADER_BG_PRELOADER_CLASSNAME,
  );

  const [bgNumber] = useState(randBgNumber());

  useEffect(() => {
    const img = new Image();

    img.src = generateWLBgURL(bgNumber);

    const onLoadImg = () => {
      setPreloaderBgClassname(
        `${HEADER_BG_PRELOADER_CLASSNAME} ${HEADER_BG_PRELOADER_CLASSNAME}__loaded`,
      );
    };

    img.addEventListener('load', onLoadImg);

    return () => {
      img.removeEventListener('load', onLoadImg);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WLHeaderBgWrapper
      className={HEADER_BG_IMAGE_CLASSNAME}
      bgURL={generateWLBgURL(bgNumber)}
    >
      <WLHeaderBg
        className={preloaderBgClassname}
        style={{ backgroundImage: `url(${previews[bgNumber]})` }}
      />
    </WLHeaderBgWrapper>
  );
};

const WLHeaderBgWrapper = styled.div<{ bgURL: string | null }>`
  height: 100% !important;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  ${({ bgURL }) =>
    !!bgURL &&
    css`
      background-image: url(${bgURL});
    `}
`;

const WLHeaderBg = styled.div`
  display: block;
  position: relative;

  object-fit: cover;

  height: 100%;
  width: 100%;

  background-size: cover;
  background-repeat: no-repeat;

  &.${HEADER_BG_PRELOADER_CLASSNAME}__loaded {
    opacity: 0;
    transition: opacity 0.75s ease 0s;
  }
`;
